import { render, staticRenderFns } from "./data-table-personal-transactions-actions.vue?vue&type=template&id=1c574d37&scoped=true&"
import script from "./data-table-personal-transactions-actions.vue?vue&type=script&lang=js&"
export * from "./data-table-personal-transactions-actions.vue?vue&type=script&lang=js&"
import style0 from "./data-table-personal-transactions-actions.vue?vue&type=style&index=0&id=1c574d37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c574d37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c574d37')) {
      api.createRecord('1c574d37', component.options)
    } else {
      api.reload('1c574d37', component.options)
    }
    module.hot.accept("./data-table-personal-transactions-actions.vue?vue&type=template&id=1c574d37&scoped=true&", function () {
      api.rerender('1c574d37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/sidesheet-additions/data-table-personal-transactions-actions.vue"
export default component.exports